import { GridSortModel } from '@mui/x-data-grid';
import { countryToAlpha2 } from "country-to-iso";
import { orderByDirection, orderByFields } from '../../constants';
import { UserInformationContainer as SourcePresaveContainer } from './styles';
import { ReactComponent as StarIcon } from 'assets/images/outlinedStar.svg'
import { ReactComponent as PresaveIcon } from 'assets/images/PreSaves.svg'

const LOCATION_BLUR_TEXT = "Xxxxxxx, XX";

export const getFormattedLocation = (
  data: {
    city?: string,
    country?: string,
    isProBrand?: boolean
  }
) => {
  if (!data.isProBrand) return LOCATION_BLUR_TEXT;
  const { city, country } = data;
  if (!city && !country) return "-";
  const countryCode = country ? countryToAlpha2(country) : "";
  const formattedLocation = [city, countryCode].filter((value) => Boolean(value)).join(', ');
  return formattedLocation || "-";
}

export const getFormattedSource = (source?: string, presaveFutureReleases?: boolean): {
  element?: JSX.Element;
  text: string;
} => {
  if (source && source?.indexOf('brandContentSlug') > -1) {
    return { text: "Signed up through website" }
  } else {
    switch (source) {
      case "presave":
        if (presaveFutureReleases) return {
          element: <SourcePresaveContainer>
            <StarIcon />
            Forever Saved
          </SourcePresaveContainer>,
          text: 'Forever Saved'
        }
        return {
          element: <SourcePresaveContainer>
            <PresaveIcon />
            Pre-saved
          </SourcePresaveContainer>,
          text: 'Pre-saved'
        }
      default:
        return { text: "Updated manually" };
    }
  }
}

export const getFormattedSort = (sortBy: GridSortModel) => {
  const { field, sort } = sortBy[0] as { field: string, sort: string };
  const orderBy = orderByFields[field] || orderByFields.added;
  const direction = orderByDirection[sort.toUpperCase()] || orderByDirection.DESC;
  return {
    orderBy,
    direction,
  }
}